import { ServerTimeService } from 'acerto-ds-services';

export default new ServerTimeService();
